module.exports = __webpack_public_path__ + "static/3-f2636770c474ae9857e17e57a6081f32.png";